import { ChangeEvent } from "react";

interface IProps {
    isChecked: boolean;
    name: string;
    label: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxInput = ({ name, onChange, label, isChecked }: IProps) => {
    return (
        <label
            htmlFor={name}
            className={"flex my-5 items-center relative"}
        >
            <input
                type="checkbox"
                name={name}
                id={name}
                checked={isChecked}
                onChange={onChange}
                className={"relative appearance-none peer rounded-full overflow-hidden w-5 h-5 outline-none ring-transparent border border-neutral-100 checked:bg-[#008DD2] checked:border-0"} />
            <span className={"ml-2 text-sm text-neutral-200 font-medium mt-0.5"}>{label}</span>
            <svg
                className="absolute w-4 h-4 ml-0.5 mt-0.5 hidden peer-checked:block text-neutral-100"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
        </label>
    );
};

export default CheckboxInput;